import { Fragment } from 'react'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import withStyles from '@mui/styles/withStyles'
import {
  muiRailClasses,
  muiTickClasses,
  muiTrackClasses,
  StyledMuiHandle,
  StyledMuiRail,
  StyledMuiTick,
  StyledMuiTrack,
} from './MuiSliderHelperStyles'

// *******************************************************
// RAIL COMPONENT
// *******************************************************
export function MuiRail({ getRailProps }) {
  return (
    <StyledMuiRail>
      <div className={muiRailClasses.railHotspot} {...getRailProps()} />
      <div className={muiRailClasses.rail} />
    </StyledMuiRail>
  )
}

MuiRail.propTypes = {
  getRailProps: PropTypes.func.isRequired,
}

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
export function MuiHandle({
  domain: [min, max],
  handle: { id, value, percent },
  getHandleProps,
  formatHandle,
}) {
  const val = formatHandle ? formatHandle(value) : value
  return (
    <StyledMuiHandle
      role="slider"
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      style={{ left: `${percent}%` }}
      {...getHandleProps(id)}
    >
      <div style={{ fontSize: 10, marginTop: -16 }}>{val}</div>
    </StyledMuiHandle>
  )
}

MuiHandle.propTypes = {
  domain: PropTypes.array.isRequired,
  formatHandle: PropTypes.func,
  handle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getHandleProps: PropTypes.func.isRequired,
}

MuiHandle.defaultProps = {
  formatHandle: undefined,
}

// *******************************************************
// TRACK COMPONENT
// *******************************************************
export function MuiTrack({ source, target, getTrackProps }) {
  const left = `${source.percent}%`
  const width = `${target.percent - source.percent}%`

  return (
    <StyledMuiTrack>
      <div className={muiTrackClasses.track} style={{ left, width }} />
      <div
        className={muiTrackClasses.trackHotspot}
        style={{ left, width }}
        {...getTrackProps()}
      />
    </StyledMuiTrack>
  )
}

MuiTrack.propTypes = {
  source: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  target: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getTrackProps: PropTypes.func.isRequired,
}

// *******************************************************
// TICK COMPONENT
// *******************************************************
export function MuiTick({ tick, idx, count, format }) {
  return (
    <StyledMuiTick>
      <div
        className={muiTickClasses.tick}
        style={{ left: `${tick.percent}%` }}
      />
      <Typography
        className={muiTickClasses.label}
        variant="caption"
        style={{
          marginLeft: `${-(100 / count) / 2}%`,
          width: `${100 / count}%`,
          left: `${tick.percent}%`,
        }}
      >
        {format(tick.value, idx, count)}
      </Typography>
    </StyledMuiTick>
  )
}

MuiTick.propTypes = {
  tick: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  format: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired,
}

MuiTick.defaultProps = {
  format: (d, idx, count) => (idx + 1 === count ? `${d}+` : d),
}
